import type { TurnPhase, Action } from '../types';

export const PHASE_ORDER: TurnPhase[] = [
  'Drawing',
  'Rolling',
  'AdjustingPerks',
  'Placing',
  'Resolving',
  'TurnEnd',
];

export const TERMINAL: TurnPhase[] = ['Win', 'Loss'];

export function isTerminal(phase: TurnPhase): boolean {
  return TERMINAL.includes(phase);
}

const allowedActionsByPhase: Record<TurnPhase, Action['type'][]> = {
  Drawing: ['startTurn'],
  Rolling: ['roll'],
  AdjustingPerks: ['adjustDie', 'rerollDie', 'finishPlacing', 'placeDie', 'useToken'],
  Placing: ['placeDie', 'unplaceDie', 'finishPlacing', 'useToken', 'adjustDie', 'rerollDie'],
  Resolving: ['acquireCard', 'endTurn'],
  TurnEnd: [],
  Win: [],
  Loss: [],
};

export function isActionAllowed(phase: TurnPhase, type: Action['type']): boolean {
  if (type === 'newGame') return true;
  return allowedActionsByPhase[phase].includes(type);
}
